import React from "react";
import block from 'bem-css-modules';
import styles from "./Loader.module.scss";

const Loader = () => {
  const b = block(styles);

  return (
    <div className={b()}>
      <span className="loader" />
    </div>
  )
}

export default Loader;